import { MenuItem } from 'primeng/api';

/**
 * Interface estendida do MenuItem do PrimeNG para suportar controle de acesso
 */
export interface ExtendedMenuItem extends MenuItem {
  /** Código da funcionalidade para controle de acesso (ver `PermissaoService.resolverAcesso`) */
  featureCode?: string;
  /** Indica se o item está bloqueado para o usuário atual */
  locked?: boolean;
  /** Lista de nomes amigáveis dos módulos que permitem acesso */
  lockedModules?: string[];
  /** Indica se o usuário atual é administrador */
  isAdmin?: boolean;
  /** Sub-itens do menu */
  items?: ExtendedMenuItem[];
}

export const TOPBAR_MENU: MenuItem[] = [
  {
    label: 'IDSS do Setor',
    items: [
      {
        label: 'Resultados por operadora',
        icon: 'mdi mdi-chart-line',
        routerLink: ['/dados-setor/idss/resultados-por-operadora'],
      },
      {
        label: 'Benchmarking',
        icon: 'mdi mdi-speedometer',
        routerLink: ['/dados-setor/idss/benchmarking'],
      },
      {
        label: 'Ranking',
        icon: 'mdi mdi-podium-gold',
        routerLink: ['/dados-setor/idss/ranking'],
      },
    ],
  },
  {
    label: 'Terminologia',
    items: [
      {
        label: 'Campos do Monitoramento TISS',
        icon: 'mdi mdi-clipboard-text-search-outline',
        routerLink: ['/dados-setor/terminologia/campos-monitoramento-tiss'],
      },
      {
        label: 'CBOs',
        icon: 'mdi mdi-professional-hexagon',
        routerLink: ['/dados-setor/terminologia/cbos'],
      },
      {
        label: 'Termos de domínios',
        icon: 'mdi mdi-equal',
        routerLink: ['/dados-setor/terminologia/termos-dominios'],
      },
      {
        label: 'Tabelas',
        icon: 'mdi mdi-clipboard-list-outline',
        routerLink: ['/dados-setor/terminologia/tabelas'],
      },
      {
        label: 'Motivos de glosa',
        icon: 'mdi mdi-format-list-group',
        routerLink: ['/dados-setor/terminologia/motivos-glosa'],
      },
      {
        label: 'Campos e críticas da ANS',
        icon: 'mdi mdi-focus-field-horizontal',
        routerLink: ['/dados-setor/terminologia/campos-criticas'],
      },
      {
        label: 'Itens e procedimentos TUSS',
        icon: 'mdi mdi-pill',
        routerLink: ['/dados-setor/terminologia/itens-procedimentos-tuss'],
      },
    ],
  },
];

export const TOPBAR_MENU_ADMIN: MenuItem[] = [
  {
    label: 'Administração',
    items: [
      {
        label: 'Operadoras',
        icon: 'mdi mdi-domain',
        routerLink: ['/operadoras'],
      },
      {
        label: 'Usuários',
        icon: 'mdi mdi-account-multiple-outline',
        routerLink: ['/usuarios'],
      },
    ],
  },
];

export const SIDEBAR_MENU: ExtendedMenuItem[] = [
  {
    label: 'INÍCIO',
    items: [
      {
        label: 'Dashboard',
        icon: 'bl bl-dashboard',
        routerLink: ['/operadora/${regans}'],
        featureCode: 'dashboard',
      },
    ],
  },

  {
    label: 'GUIAS TISS',
    items: [
      {
        label: 'Críticas das guias e itens',
        icon: 'bl bl-criticas-guias-itens',
        routerLink: ['/operadora/${regans}/guias-tiss/critica-guias'],
        featureCode: 'criticas_guias_itens',
      },
      {
        label: 'Resumo do histórico das críticas',
        icon: 'bl bl-resumo-historico-criticas',
        routerLink: ['/operadora/${regans}/criticas/resumo-historico-criticas'],
        featureCode: 'resumo_historico_criticas',
      },
      {
        label: 'Resumo de guias',
        icon: 'bl bl-resumo-guias',
        routerLink: ['/operadora/${regans}/guias-tiss/resumo-guias'],
        featureCode: 'resumo_guias',
      },
      {
        label: 'Resumo de itens das guias',
        icon: 'bl bl-resumo-itens-das-guias',
        routerLink: ['/operadora/${regans}/guias-tiss/resumo-itens-guias'],
        featureCode: 'resumo_itens_guias',
      },
      {
        label: 'Retornos da ANS',
        icon: 'bl bl-retornos-ans',
        routerLink: ['/operadora/${regans}/guias-tiss/retornos-ans'],
        featureCode: 'retornos_ans',
      },
      {
        label: 'Listagem de guias',
        icon: 'bl bl-listagem-guias',
        routerLink: ['/operadora/${regans}/guias-tiss/listagem-guias'],
        featureCode: 'listagem_guias',
      },
      {
        label: 'Lançamentos e valores das guias',
        icon: 'bl bl-lancamentos-valores-guias',
        routerLink: ['/operadora/${regans}/guias-tiss/lancamentos-guias'],
        featureCode: 'lancamentos_valores_guias',
      },
      {
        label: 'Correção de guias e itens',
        icon: 'bl bl-correcao-guias',
        routerLink: ['/operadora/${regans}/guias-tiss/correcao-guias'],
        visible: false,
        featureCode: 'correcao_guias_itens',
      },
      { label: 'Resumo dos motivos de rejeição', disabled: true, visible: false },
      { label: 'Tabela TUSS Incorreta', disabled: true, visible: false },
    ],
  },

  {
    label: 'REMUNERAÇÕES',
    visible: false,
    items: [
      { label: 'Valores informados - TISS', disabled: true },
      { label: 'Tabela TUSS incorreta', disabled: true },
    ],
  },

  {
    label: 'OUTRAS REMUNERAÇÕES',
    visible: true,
    items: [
      {
        label: 'Valor preestabelecido',
        icon: 'bl bl-valor-preestabelecido',
        routerLink: ['/operadora/${regans}/outras-remuneracoes/valor-preestabelecido'],
        featureCode: 'valor_preestabelecido',
      },
      {
        label: 'Fornecimento direto',
        icon: 'bl bl-fornecimento-direto',
        routerLink: ['/operadora/${regans}/outras-remuneracoes/fornecimento-direto'],
        featureCode: 'fornecimento_direto',
      },
      {
        label: 'Despesas assistenciais',
        icon: 'bl bl-despesas-assistenciais',
        routerLink: ['/operadora/${regans}/outras-remuneracoes/despesas-assistenciais'],
        featureCode: 'despesas_assistenciais',
      },
    ],
  },

  {
    label: 'SIMULADOR',
    items: [
      {
        label: 'Simulador/Projeções',
        icon: 'bl bl-simulador-projecoes',
        routerLink: ['/operadora/${regans}/simulador-idss'],
        featureCode: 'simulador',
      },
      {
        label: 'Análises',
        icon: 'bl bl-analises',
        routerLink: ['/operadora/${regans}/simulador/analises'],
        featureCode: 'conformidade',
      },
      {
        label: 'Comparativo TISS e DIOPS',
        icon: 'bl bl-comparativo-tiss-diops',
        routerLink: ['/operadora/${regans}/guias-tiss/comparativo-tiss-diops'],
        featureCode: 'comparativo_tiss_diops',
      },
    ],
  },

  {
    label: 'ARQUIVOS',
    items: [
      {
        label: 'Postar',
        icon: 'bl bl-postar',
        routerLink: ['/operadora/${regans}/arquivos/postar'],
        featureCode: 'postar_arquivos',
      },
      {
        label: 'Arquivos da operadora',
        icon: 'pi pi-folder-open', // TODO: trocar ícone futuramente
        routerLink: ['/operadora/${regans}/arquivos/arquivos-postados'],
        featureCode: 'arquivos_operadora',
      },
      {
        label: 'Lotes XTE',
        icon: 'bl bl-lotes-xte',
        routerLink: ['/operadora/${regans}/arquivos/lotes-xte'],
        featureCode: 'lotes_xte',
      },
      {
        label: 'Baixar',
        icon: 'bl bl-baixar',
        routerLink: ['/operadora/${regans}/arquivos/baixar'],
        featureCode: 'baixar_arquivos',
      },
      {
        label: 'Situação',
        icon: 'bl bl-situacao',
        routerLink: ['/operadora/${regans}/arquivos/situacao'],
        featureCode: 'situacao_arquivos',
      },
    ],
  },

  {
    label: 'MINHA OPERADORA',
    items: [
      {
        label: 'Planos de saúde',
        icon: 'bl bl-planos-saude',
        routerLink: ['/operadora/${regans}/minha-operadora/planos-de-saude'],
        featureCode: 'planos_saude',
      },
      {
        label: 'Pacotes e procedimentos próprios',
        icon: 'bl bl-pacotes-procedimentos-proprios',
        routerLink: ['/operadora/${regans}/minha-operadora/pacotes-e-procedimentos'],
        featureCode: 'pacotes_procedimentos_proprios',
      },
      {
        label: 'Resumo do CNX',
        icon: 'bl bl-resumo-guias', // TODO: trocar ícone futuramente
        routerLink: ['/operadora/${regans}/minha-operadora/resumo-cnx'],
        featureCode: 'resumo_cnx',
      },
    ],
  },

  {
    label: 'POC',
    visible: false,
    items: [
      {
        label: 'AG Grid',
        routerLink: ['/operadora/${regans}/poc/ag-grid'],
      },
      {
        label: 'ORDS API Test',
        routerLink: ['/operadora/${regans}/poc/ords-api-test'],
      },
      {
        label: 'APEX in iframe',
        routerLink: ['/operadora/${regans}/poc/apex-iframe'],
      },
    ],
  },

  {
    label: 'AJUDA',
    visible: false,
    items: [
      {
        label: 'Documentação arquitetura',
        url: '/assets/doc/index.html',
        target: '_blank',
      },
      {
        label: 'Tema',
        url: 'https://primefaces.org/ultima-ng/#/documentation',
        target: '_blank',
      },
    ],
  },
];
